import { render, staticRenderFns } from "./mainAdminLineCross.vue?vue&type=template&id=708ac76c&scoped=true"
import script from "./mainAdminLineCross.vue?vue&type=script&lang=js"
export * from "./mainAdminLineCross.vue?vue&type=script&lang=js"
import style0 from "./mainAdminLineCross.vue?vue&type=style&index=0&id=708ac76c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708ac76c",
  null
  
)

export default component.exports